// Field labels
export const FIELD_LABELS = {
    EXIT_DATE: 'Stop Production Date *',
    END_OF_PRODUCTION_DATE: 'End of Production Date',
    END_OF_IMPORTATION_DATE: 'End of Importation Date',
    REPLACEMENT_PLAN: 'Replacement Plan *',
    LIQUIDATION_PLAN: 'Liquidation Plan *',
    ADDITIONAL_COMMENTS: 'Additional Comments'
};

// Error messages
export const ERROR_MESSAGES = {
    EXIT_DATE: 'Stop production date',
    END_OF_PRODUCTION_DATE: 'End of production date',
    END_OF_IMPORTATION_DATE: 'End of importation date',
    REPLACEMENT_PLAN: 'Replacement plan',
    LIQUIDATION_PLAN: 'Liquidation plan',
    REQUIRED_SUFFIX: ' is required'
};

// Button labels
export const BUTTON_LABELS = {
    DELETE_PLAN: 'Delete',
    UPDATE_PLAN: 'Update Exit Plan',
    CREATE_PLAN: 'Create Exit Plan',
    UPDATE_EXEMPTION: 'Update Exemption Request',
    CREATE_EXEMPTION: 'Create Exemption Request'
};

// Plan type switch
export const TYPE_SWITCH_LABEL = 'Fill this as:';

// Alert messages
export const ALERT_MESSAGES = {
    SUPPORT_WARNING: 'Support request not selected. Switch to Support Request tab if you need assistance.'
};

// Restriction types
export const RESTRICTION_TYPES = {
    BANNED: 'BANNED'
};

// Default values
export const DEFAULTS = {
    RESTRICTION_TYPE: 'BANNED',
    TEXT_FIELD_ROWS: 2
};